/**
 * Imaging sources (DEXIS import, Phase 1): Settings > Imaging sources.
 * Add or enable an office's DEXIS source (push with an office upload key,
 * or pull from the office read service), set its backfill window, PMS match
 * and throttle, watch import progress and backup lag, and work the review
 * queue. Owners and admins only (`settings.manage`). API:
 * `/v1/imaging-ingest/sources`, `/upload-keys`.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'imaging-sources',
    title: 'Imaging sources',
    version: '0.1.0',
    owner: 'WP2-IMAGING-INGEST',
    entitlementKey: null,
    permissions: ['settings.manage', 'imaging.view'],
    routes: [
      {
        id: 'sources',
        path: '/settings/imaging-sources',
        title: 'Imaging sources',
        officeScope: 'location-or-all',
        permission: 'settings.manage',
        readsPhi: false,
      },
    ],
    nav: [
      {
        label: 'Imaging sources',
        group: 'settings',
        routeId: 'sources',
        icon: 'scan-line',
        order: 937,
        permission: 'settings.manage',
      },
    ],
    commands: [
      {
        id: 'imaging-sources.open',
        title: 'Imaging sources',
        keywords: ['dexis', 'import', 'x-ray import', 'backfill', 'upload key', 'review queue'],
        routeId: 'sources',
      },
    ],
    sseEntityKeys: ['imaging_source'],
    phiReadPoints: [],
  }),
  pages: {
    sources: () => import('./ImagingSourcesPage.js'),
  },
});
